import { Statistic } from "./types";

export const getWelcomeCardStats = (
  customersTotal: number,
  unitsTotal: number,
  unitDescriptionTotal: number,
  locationsTotal: number,
  insurancesTotal: number,
  gatesTotal: number,
  errors: {
    customers?: boolean;
    units?: boolean;
    unitDescription?: boolean;
    locations?: boolean;
    insurances?: boolean;
    gates?: boolean;
    sync?: boolean;
  },
  syncModuleReady: boolean = false,
): Statistic[] => {
  const totalRecords =
    Number(customersTotal ?? 0) +
    Number(unitsTotal ?? 0) +
    Number(unitDescriptionTotal ?? 0) +
    Number(locationsTotal ?? 0) +
    Number(insurancesTotal ?? 0) +
    Number(gatesTotal ?? 0);

  const counts = {
    customers: customersTotal,
    units: unitsTotal,
    sizes: unitDescriptionTotal,
    locations: locationsTotal,
    insurances: insurancesTotal,
    gates: gatesTotal,
  };

  let activeModules = Object.values(counts).filter((count) => count > 0).length;

  if (syncModuleReady && !errors.sync) {
    activeModules += 1;
  }

  const TOTAL_MODULES = 7;
  const errorCount = Object.values(errors).filter(Boolean).length;

  return [
    {
      value: totalRecords.toLocaleString(),
      label: "Total Records",
      color: "text-primary",
    },
    {
      value: `${activeModules} / ${TOTAL_MODULES}`,
      label: "Active Modules",
      color: "text-green-600",
    },
    {
      value: errorCount.toString(),
      label: "Detected Errors",
      color: errorCount > 0 ? "text-red-500" : "text-gray-400",
    },
  ];
};
